import { useLingui } from "@lingui/react/macro";

import { formatPercent } from "@/features/matches";
import { cn } from "@/shared/lib";

// `time` — среднее время покупки у сильных рядом с долей: «35 % · 22:54».
// `close` — вариант «почти» (`close_ids`): жёлтой полосой.
type ShareBar = {
  id: string;
  name: string;
  share: number;
  correct: boolean;
  close?: boolean;
  time?: string | null;
};

type ShareBarsProps = { caption: string; bars: ShareBar[] };

// Полосы долей после ответа: верный вариант — зелёной полосой, больше — выше.
export const ShareBars = ({ caption, bars }: ShareBarsProps) => {
  const { i18n } = useLingui();
  const sorted = [...bars].sort((a, b) => b.share - a.share);
  return (
    <div className="flex flex-col gap-2">
      <span className="text-[13px] text-muted">{caption}</span>
      {sorted.map((bar) => (
        <div
          key={bar.id}
          className="grid grid-cols-[minmax(0,170px)_minmax(0,1fr)_auto] items-center gap-2.5 text-sm"
        >
          <span className="truncate">{bar.name}</span>
          <span className="block h-2.5 overflow-hidden rounded-full bg-sidebar-active">
            <span
              className={cn(
                "block h-full",
                bar.correct ? "bg-good" : bar.close === true ? "bg-warn" : "bg-neutral",
              )}
              style={{ width: `${Math.round(Math.min(1, bar.share) * 100)}%` }}
            />
          </span>
          <span className="min-w-12 text-right font-mono whitespace-nowrap">
            {formatPercent(bar.share, i18n.locale)}
            {bar.time != null && <span className="text-muted"> · {bar.time}</span>}
          </span>
        </div>
      ))}
    </div>
  );
};
